import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'

import { Store } from '@ngrx/store'
import { DialogModule } from 'primeng/dialog'
import { ImageModule } from 'primeng/image'
import { ProgressBarModule } from 'primeng/progressbar'
import { TooltipModule } from 'primeng/tooltip'

import { AiSelectors } from '@flowx/designer/modules/new-ai/store/ai.selectors'

@Component({
  selector: 'flx-ai-agent-reasoning',
  imports: [CommonModule, DialogModule, ImageModule, ProgressBarModule, TooltipModule],
  templateUrl: './agent-reasoning.component.html',
  styleUrls: ['./agent-reasoning.component.scss'],
  standalone: true,
})
export class AgentReasoningComponent {
  #store = inject(Store)

  reasoningLogs = this.#store.selectSignal(AiSelectors.reasoningLogs)
}
